module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', _vm._l((_vm.docs), function(item) {
    return _c('div', {
      staticClass: "mar"
    }, [_c('h3', [_vm._v(_vm._s(item.h3))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p1))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p2))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p3))]), _vm._v(" "), _c('p', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item.p4))])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "id": "about"
    }
  }, [_vm._v("“共创台球”模式"), _c('br'), _vm._v("一起畅玩")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8aa58894"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutContent.vue
// module id = 167
// module chunks = 1